/**
 * @license BCP
 * (c) 2015 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc module
 * @name selector
 * @description
 *
 * # selector
 *
 * The `selector` module provides selector component.
 */

/**
 * @ngdoc factory
 * @name selector
 *
 * @description
 * A factory which create selectors content.
 */
angular.module("selector", [])
  .factory("selector", function () {

    var data = [];

    return {

      set: function (key, type, item) {
        // init as empty array if it does not exist
        if (!data[key][type] && !angular.isArray(data[key][type])) {
          data[key][type] = [];
        }
        if (data[key][type].indexOf(item) === -1) {
          data[key][type].push(item);
        } else {
          data[key][type].splice(data[key][type].indexOf(item), 1);
        }
        // there is hack, because ng-model could not catch splice???!!!
        data[key][type] = data[key][type].slice(0);
      },

      clear: function (key, type) {
        data[key][type] = [];
        data[key].content[type].forEach( function (item) {
          item.active = false;
        });
      },

      get: function (key, type) {
        return data[key][type];
      },

      getAllData: function () {
        return data;
      },

      setContent: function (key, type, content, items) {
        if (!data[key]) {
          data[key] = {
            content: {},
          };
        }
        data[key].content[type] = [];
        content.forEach( function (item) {
           data[key].content[type].push({
            active: items.indexOf(item) === -1 ? false : true,
            name: item,
           });
        });
        data[key][type] = items;
      },

      removeContent: function (key) {
        if (data[key]) {
          data[key] = null;
        }
      }
    };
  })
  /**
 * @ngdoc directive
 * @name selector
 *
 * @description
 * Selector component which show selector data
 */
.directive("selector", function (selector) {
    return {
      restrict: "E",
      scope: {
        key: '@',
        type: '@',
        limit: '@',
        increment: '@',
        selectorstyle: '@',
        placeholder: '@',
        cleartooltip: '@',
        selectortext: '@',
      },
      templateUrl: "components/selector/selector.html",
      controller: function ($scope) {

        $scope.data = selector.getAllData();

        $scope.set = function (key, type, item, value) {
          selector.set(key, type, item, value);
        };

        $scope.clear = function (key, type) {
          selector.clear(key, type);
        };

        $scope.lazyLoad = function () {
          if ($scope.increment) {
            $scope.limit += $scope.increment;
          } else {
            $scope.limit += 100;
          }
        };

      } 
    };
  })
  /**
 * @ngdoc directive
 * @name whenScrolled
 *
 * @description
 * Selector attribute which show more data in dropdown menu
 */
.directive('whenScrolled', function() {
    return function(scope, elm, attr) {
      var raw = elm[0];
      
      elm.bind('scroll', function() {
        if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
          scope.$apply(attr.whenScrolled);
        }
      });
    };
  });

})();
